/*
 * Human Standard — shared reveal observer.
 *
 * Reveals elements marked with `data-kn-reveal` once, as they enter the
 * viewport. Deliberately tiny and dependency-free.
 *
 * Progressive enhancement contract:
 *   - The pre-reveal hidden state lives behind the `kn-js` class on <html>,
 *     which theme.liquid only sets when JS runs and reduced motion is off.
 *   - If this file fails to load, `kn-js` is still absent-safe: elements are
 *     visible because the hidden state is scoped to `.kn-js`.
 *   - Each element is revealed once and then unobserved, so nothing replays.
 */
(function () {
  'use strict';

  var root = document.documentElement;

  // Reduced motion or no observer support: nothing to do, content is visible.
  if (!root.classList.contains('kn-js') || !('IntersectionObserver' in window)) {
    return;
  }

  function revealAll(scope) {
    var targets = (scope || document).querySelectorAll('[data-kn-reveal]:not(.kn-revealed)');
    for (var i = 0; i < targets.length; i++) {
      targets[i].classList.add('kn-revealed');
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kn-revealed');
        observer.unobserve(entry.target);
      });
    },
    // Reveal slightly before the element is fully in view so it never feels late.
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  function observe(scope) {
    var targets = (scope || document).querySelectorAll('[data-kn-reveal]:not(.kn-revealed)');
    for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i]);
    }
  }

  observe(document);

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  // Safety net: if anything is still hidden after load, show it rather than
  // risk content staying invisible.
  window.addEventListener('load', function () {
    window.setTimeout(function () {
      var stillHidden = document.querySelectorAll('[data-kn-reveal]:not(.kn-revealed)');
      for (var i = 0; i < stillHidden.length; i++) {
        var rect = stillHidden[i].getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          stillHidden[i].classList.add('kn-revealed');
        }
      }
    }, 1200);
  });

  // Exposed only so sections can force-reveal their own content if needed.
  window.KnownMotion = { reveal: revealAll };
})();
